import React, { useState, useEffect } from "react";
import {
  Tabs,
  Tab,
  Box,
  Paper,
  Chip,
  CircularProgress,
  Backdrop,
  Typography,
  Select,
  MenuItem,
  TextField,
  Button,
  ListItemText,
  Checkbox,
  FormControl,
  Grid,
  Autocomplete,
} from "@mui/material";
import DataTable from "../../components/table/DataTable";
import CustomizedTables from "../../components/table/TasksTable";
import { useNavigate } from "react-router-dom";
import { useGetTokenOrLogout } from "../../utils/token";
import CustomAutocompleteComp from "../../newTestPrep/newComponent/AutocompleteComp";
import CustomTextFieldComp from "../../newTestPrep/newComponent/customTextFieldComp";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function TaskReportTabs({ onClose }) {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();

  const [reportType, setReportType] = useState("today");
  const [filterType, setFilterType] = useState("today");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [todayTaskReportData, setTodayTaskReportData] = useState([]);
  const [monthlyTaskReportData, setMonthlyTaskReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [createdby, setCreatedby] = useState([]);
  const [createdbylist, setCreatedbylist] = useState([]);

  const [filterData, setFilterData] = useState({
    filterType: "today",
    fromDate: null,
    toDate: null,
    filterFor: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getalluser`);
        if (response.ok) {
          const data = await response.json();
          setCreatedbylist(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const allUserList = [{ first_name: "Select All" }, ...createdbylist];
  const handelcretedby = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setCreatedby(createdbylist);
    } else {
      setCreatedby(value);
    }
  };

  const fetchTodayTaskReport = async () => {
    setIsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    // Simulate API fetch or set your actual data

    const apiUrl = `${API_ENDPOINT}route/todaytask`;

    try {
      // const response = await fetch(apiUrl);
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify({
          user_id: parseInt(userId),
          filter: filterType,
          to_date: fromDate,
          from_date: toDate,
          filter_for: createdby.map((i) => i.id) || [],
        }),
      });

      if (response.ok) {
        const data = await response.json();

        setTodayTaskReportData(data);
        setFilterData({
          filterType: filterType,
          fromDate: fromDate || null,
          toDate: toDate || null,
          filterFor: createdby.map((i) => i.id) || [],
        });
        setIsLoading(false);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/page403");
      } else if (response.status === 440) {
        navigate("/page440");
      } else {
        navigate("/page500");
      }
      // return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
      navigate("/page404");
      throw new Error("Failed to fetch data");
    }
    setIsLoading(false);
  };

  // Simulate fetching data for today's and monthly task reports
  useEffect(() => {
    fetchTodayTaskReport();
  }, []);

  const handleChipClick = (type) => {
    setReportType(type);
  };

  const handleClose = () => {
    onClose();
  };

  const handleFilterChange = (event) => {
    setFilterType(event.target.value);
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handleApplyFilter = () => {
    fetchTodayTaskReport();
  };

  return (
    <div>
      {/*} <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>Fetching</Typography>
        <CircularProgress color="primary" />
  </Backdrop>*/}
      <Grid container spacing={2} justifyContent="center">
        {(userRole === "center_admin" || userRole === "data_entry") && (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Select Task Owner </Typography>

            <CustomAutocompleteComp
              fullWidth
              multiple
              value={createdby}
              onChange={handelcretedby}
              options={allUserList}
              getOptionLabel={(option) =>
                `${option.first_name ? option.first_name : ""} ${
                  option.last_name ? option.last_name : ""
                }`
              }
              tooltipContent={(option) =>
                `${option.first_name ? option.first_name : ""} ${
                  option.last_name ? option.last_name : ""
                }`
              }
            />
          </Grid>
        )}

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Typography variant="h6">Filter For</Typography>
          <Select
            size="normal"
            value={filterType}
            onChange={handleFilterChange}
            fullWidth
            style={{ borderRadius: "10px" }}
          >
            <MenuItem value="today">Today</MenuItem>
            <MenuItem value="1week">Last 7 Days</MenuItem>
            <MenuItem value="1month">Last 30 days</MenuItem>
            <MenuItem value="custom">Custom</MenuItem>
          </Select>
        </Grid>

        {filterType === "custom" && (
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">  Due Date From </Typography>
                <CustomTextFieldComp
                  fullWidth
                  type="date"
                  value={fromDate}
                  onChange={handleFromDateChange}
                  InputLabelProps={{ shrink: true }}
                  size="normal"
                  InputProps={{
                    style: { borderRadius: "10px" }, // Add borderRadius here
                  }}
                  // inputProps={{ max: new Date().toISOString().split('T')[0] }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="h6">  Due Date To</Typography>
                <CustomTextFieldComp
                  fullWidth
                  type="date"
                  value={toDate}
                  onChange={handleToDateChange}
                  InputLabelProps={{ shrink: true }}
                  size="normal"
                  InputProps={{
                    style: { borderRadius: "10px" }, // Add borderRadius here
                  }}
                  // inputProps={{ max: new Date().toISOString().split('T')[0] }}
                />
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Typography variant="h6" visibility="hidden">
            {" "}
            To Date
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={handleApplyFilter}
          >
            Apply Filter
          </Button>
        </Grid>
      </Grid>

      <Box mt={2}>
        {isLoading ? (
          <Box display="flex" justifyContent="center" mt={2}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {reportType === "today" ? (
              <CustomizedTables
                data={todayTaskReportData}
                reportType={reportType}
                onClose={handleClose}
                filterData={filterData}
              />
            ) : (
              <CustomizedTables
                data={monthlyTaskReportData}
                reportType={reportType}
              />
            )}
          </>
        )}
      </Box>
    </div>
  );
}

export default TaskReportTabs;
